import { Box, Tabs, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { useAtom, useAtomValue } from 'jotai';
import React, { useCallback, useMemo } from 'react';
import { activeTabIdAtom, isScanningAtom, unsavedChangedHandlersAtom } from '../atoms/session-atoms';
import { BiCtaNames } from '../bi/types';
import { showSaveBeforeCloseModal } from '../components/modals/show-save-before-leave-modal';
import { ACCESSIBILITY_WIZARD_TAB_IDS } from '../consts';
import { useA11yWizardAdapter } from '../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../hooks/use-bi-logger';
import { useResetUnsavedChangesHandlers } from '../hooks/use-reset-unsaved-changes-handlers';
export const TabTitle = _ref => {
  let {
    issuesNumber,
    text,
    currentTabId,
    tabId
  } = _ref;
  const isScanning = useAtomValue(isScanningAtom);
  const skin = currentTabId === tabId ? 'primary' : 'standard';
  return /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "3px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    skin: skin,
    tabIndex: -1,
    weight: "thin",
    ellipsis: true
  }, text), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    skin: skin,
    weight: "normal"
  }, `(${isScanning ? issuesNumber === 0 ? '-' : issuesNumber : issuesNumber})`));
};
export const TabsWrapper = _ref2 => {
  let {
    detectedIssuesNumber,
    manualTasksNumber
  } = _ref2;
  const {
    t
  } = useTranslation();
  const [currentTabId, setCurrentTabId] = useAtom(activeTabIdAtom);
  const unsavedChangedHandlers = useAtomValue(unsavedChangedHandlersAtom);
  const {
    resetUnsavedChangesHandlers
  } = useResetUnsavedChangesHandlers();
  const biLogger = useBiLogger();
  const {
    a11yWizardAdapter,
    editorHost
  } = useA11yWizardAdapter();
  const navigateToTab = useCallback(value => {
    biLogger.ctaClick({
      ctaName: `${BiCtaNames.NavigateToTab}-${value.id}`
    });
    setCurrentTabId(value.id);
  }, [biLogger, setCurrentTabId]);
  const onClickTab = useCallback(newTab => {
    if (unsavedChangedHandlers != null && unsavedChangedHandlers.exists) {
      showSaveBeforeCloseModal({
        a11yWizardAdapter,
        biLogger,
        editorHost,
        handleApply: unsavedChangedHandlers.apply,
        handleDiscard: () => {
          navigateToTab(newTab);
          resetUnsavedChangesHandlers();
        },
        t
      });
    } else {
      navigateToTab(newTab);
    }
  }, [a11yWizardAdapter, biLogger, editorHost, navigateToTab, resetUnsavedChangesHandlers, t, unsavedChangedHandlers == null ? void 0 : unsavedChangedHandlers.apply, unsavedChangedHandlers == null ? void 0 : unsavedChangedHandlers.exists]);
  const tabItems = useMemo(() => [{
    id: ACCESSIBILITY_WIZARD_TAB_IDS.DETECTED_TASKS,
    title: /*#__PURE__*/React.createElement(TabTitle, {
      currentTabId: currentTabId,
      issuesNumber: detectedIssuesNumber,
      tabId: ACCESSIBILITY_WIZARD_TAB_IDS.DETECTED_TASKS,
      text: t('accessibility-wizard.tabs.detected-issues')
    })
  }, {
    id: ACCESSIBILITY_WIZARD_TAB_IDS.MANUAL_TASKS,
    title: /*#__PURE__*/React.createElement(TabTitle, {
      currentTabId: currentTabId,
      issuesNumber: manualTasksNumber,
      tabId: ACCESSIBILITY_WIZARD_TAB_IDS.MANUAL_TASKS,
      text: t('accessibility-wizard.tabs.manual-tasks')
    })
  }], [currentTabId, detectedIssuesNumber, manualTasksNumber, t]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, currentTabId && /*#__PURE__*/React.createElement(Tabs, {
    activeId: currentTabId,
    items: tabItems,
    size: "small",
    type: "uniformSide",
    width: "128px",
    hasDivider: true,
    onClick: onClickTab
  }));
};
//# sourceMappingURL=a11y-wizard-panel-tabs.js.map